import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Footer from '../../components/Footer';
import ContentBlocks from '../../components/ContentBlocks';
import { blogPosts, getPostBySlug } from '../../data/blogPosts';
import { formatDate } from '../../data/liveClasses';
import '../Blog/index.css';

const BlogPost = () => {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  useEffect(() => {
    document.title = post ? `${post.title} | Codeazy` : 'Article not found | Codeazy';
    return () => { document.title = 'Codeazy'; };
  }, [post]);

  if (!post) {
    return (
      <div className="page blog-page">
        <div className="container article-not-found">
          <h1>Article not found</h1>
          <p>The article you are looking for doesn't exist or has moved.</p>
          <Link to="/blog" className="back-link"><ArrowBackIcon sx={{ fontSize: 18 }} /> Back to blog</Link>
        </div>
      </div>
    );
  }

  const related = blogPosts
    .filter((p) => p.slug !== post.slug)
    .sort((a, b) => (b.category === post.category) - (a.category === post.category))
    .slice(0, 2);

  return (
    <div className="page blog-page">
      <article className="container article">
        <Link to="/blog" className="back-link"><ArrowBackIcon sx={{ fontSize: 18 }} /> All articles</Link>
        <header className="article-header">
          <span className="blog-category">{post.category}</span>
          <h1>{post.title}</h1>
          <div className="blog-meta">
            <span>{post.author}</span>
            <span>·</span>
            <span>{formatDate(post.date)}</span>
            <span>·</span>
            <span>{post.readTime} min read</span>
          </div>
        </header>

        <ContentBlocks blocks={post.content} />

        <ul className="article-tags">
          {post.tags.map((tag) => <li key={tag}>#{tag}</li>)}
        </ul>

        <div className="article-cta">
          <div>
            <h3>Want to learn this with a mentor?</h3>
            <p>Join an upcoming live cohort and prepare with industry engineers.</p>
          </div>
          <Link to="/live-classes" className="btn-gradient">See live classes</Link>
        </div>

        {related.length > 0 && (
          <section className="article-related">
            <h2>Keep reading</h2>
            <div className="blog-grid">
              {related.map((p) => (
                <Link to={`/blog/${p.slug}`} className="blog-card" key={p.slug}>
                  <span className="blog-category">{p.category}</span>
                  <h3>{p.title}</h3>
                  <p>{p.excerpt}</p>
                </Link>
              ))}
            </div>
          </section>
        )}
      </article>
      <Footer />
    </div>
  );
};

export default BlogPost;
